<div class="cargo-position-condition-editor" *ngIf="condition" [formGroup]="detailsFormGroup">
    
    <div class="row">
        <mat-form-field class="flex-grow">
            <input matInput formControlName="cargoposition" name="cargoposition" maxlength="255"
                placeholder="{{'cargoposition ' | translate: ['tmc-yard.entity.transport.cargoOfRoutingPositions', translationService.language]}}"
                [maxlength]="255">
        </mat-form-field>
    </div>
</div>